import { Game, QuickRankConfiguration, QuickRankMode, GameKind } from "../../gql/graphql";

export type QuickPickGame = Omit<Game, "configuration"> & {
  configuration: QuickRankConfiguration & { mode: QuickRankMode.AllUp };
};
export function isQuickPickGame(game?: Game | null): game is QuickPickGame {
  return (
    game?.kind === GameKind.QuickRank && (game.configuration as QuickRankConfiguration).mode === QuickRankMode.AllUp
  );
}
